module.exports = __webpack_public_path__ + "img/coupon.a151647d.png";